{
    if(window.eHanlin === undefined || window.eHanlin === null){
        window.eHanlin = {}
    }
    if(window.eHanlin.platform_env === undefined || window.eHanlin.platform_env === null){
        window.eHanlin.platform_env = {}
        window.eHanlin.platform_env.cdn = 'https://ehanlin-web-public-resource.s3-ap-northeast-1.amazonaws.com'
    }
    const template = `
        <style>
            .loading{
                background-color:rgba(255, 255, 255, 0.8);
                position:fixed;
                width:100%;
                height:100%;
                z-index:100000;
                top:0;
                left:0;
                display:-webkit-box;
                display:-ms-flexbox;
                display:flex;
                -webkit-box-pack:center;
                -ms-flex-pack:center;
                justify-content:center;
                -webkit-box-align:center;
                -ms-flex-align:center;
                align-items:center;
                -moz-user-select:none;
                -webkit-user-select:none;
                -ms-user-select:none;
                user-select:none;
            }
            .loading .flip-book{
                width:120px
            }
            .loading img{
                width:100%
            }
        </style>
        <div class="loading">
            <div class="flip-book">
                <img src="${window.eHanlin.platform_env.cdn}/web/eh-loading/book.gif" alt="翻書">
            </div>
        </div>
    `;
    customElements.define('eh-loading', class extends HTMLElement {
        constructor() {
            super();
            const shadowRoot = this.attachShadow({mode: 'open'});
            shadowRoot.innerHTML = template;
        }
    });
}
